module.exports = __webpack_public_path__ + "static/media/chat.2cf950a6.svg";